<template>
    <div class="form-check">
        <input
            type="checkbox"
            class="form-check-input"
            :required="$attrs.required"
            @change="$emit('filled-out', $event.target.checked)"
        >
        <FieldLabel :label="field.label" :fieldId="field.id"/>
    </div>
</template>

<script>
  import FieldLabel from '../FieldLabel';

  export default {
    props: {
      field: {},
    },
    components: {
      FieldLabel,
    },
  };
</script>
